import React, { useEffect, useState } from "react";
import "./Search_products.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faXmark } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import { DropdownButton } from "react-bootstrap";
import { useForm } from "react-hook-form";
import Gray_Outline_Button from "../../common-components/common-btn/gray_outline_btn/Gray_Outline_Button";
import Red_Outline_Btn from "../../common-components/common-btn/red_outline_btn/Red_Outline_Btn";

const Search_products = ({
  handleFilterReset,
  filters,
  onFilterChange,
  onClick,
}) => {
  const { register, getValues, setValue } = useForm();

  const [selected, setSelected] = useState(null);

  useEffect(() => {}, []);
  const handleClick = () => {
    let name = getValues("name");
    onFilterChange("name", name);
  };

  const options = [
    { key: "default", value: "Default" },
    { key: "ASC", value: "Price Low to High" },
    { key: "DESC", value: "Price High to Low" },
    { key: "NEW", value: "Newest" },
    { key: "POPULAR", value: "Most Popular" },
  ];

  const handleSort = (item) => {
    setSelected(item.value);
    onFilterChange("sortBy", item.key);
  };

  return (
    <>
      <section className="Search_products_sec">
        <div className="trendingsearches">
          <div className="mobile_filter_div " onClick={onClick}>
            <FontAwesomeIcon icon={faFilter} className="filter_icon" />
          </div>
<div className="desktop_view_filtered_product_list">

          <div className="topsearches">
            {Object.entries(filters).map(([key, value]) => {
              // Only process arrays with a length greater than 0
              if (Array.isArray(value) && value.length > 0) {
                return value.map((item) => (
                  <p className="searches" key={`${key}-${item.id}`}>
                    <span>{item.name}</span>
                    <FontAwesomeIcon
                      icon={faXmark}
                      onClick={() => {
                        onFilterChange(key, item);
                      }}
                    />
                  </p>
                ));
              }
              // Handle string values if needed (like 'sortBy' or 'name')
              if (typeof value === "string" && value) {
                return (
                  <p className="searches" key={key}>
                    <span>{value}</span>
                    <FontAwesomeIcon
                      icon={faXmark}
                      onClick={() => {
                        onFilterChange(key, null);
                      }}
                    />
                  </p>
                );
              }
              return null;
            })}
            {/* <p className="searches">
              <span>Sunglasses</span>
              <FontAwesomeIcon icon={faXmark} />
            </p>
            <p className="searches">
              <span>Sunglasses</span>
              <FontAwesomeIcon icon={faXmark} />
            </p>
            <p className="searches">
              <span>Sunglasses</span>
              <FontAwesomeIcon icon={faXmark} />
            </p> */}
          </div>
</div>

          <div className="sortbyprod">
            <DropdownButton
              id="dropdown-filter"
              title={selected || "Sort by"}
              className="custom-dropdown"
            >
              {options.map((item, idx) => (
                <Dropdown.Item
                  as="button"
                  key={idx}
                  onClick={() => handleSort(item)}
                  className={`dropdown-radio-item ${
                    selected === item?.value ? "active" : ""
                  }`}
                >
                  <div className="radio-option">
                    <input
                      type="radio"
                      name="filter"
                      checked={selected === item?.value}
                      readOnly
                    />
                    <label>{item?.value}</label>
                  </div>
                </Dropdown.Item>
              ))}
            </DropdownButton>

            <div className="reset_btn">
              <Red_Outline_Btn btnText="Reset" onClick={handleFilterReset} />
            </div>
          </div>
        </div>
<div className="mobile_view_filtered_product_list">
         <div className="trendingsearches">
         

          <div className="topsearches">
            {Object.entries(filters).map(([key, value]) => {
              // Only process arrays with a length greater than 0
              if (Array.isArray(value) && value.length > 0) {
                return value.map((item) => (
                  <p className="searches" key={`${key}-${item.id}`}>
                    <span>{item.name}</span>
                    <FontAwesomeIcon
                      icon={faXmark}
                      onClick={() => {
                        onFilterChange(key, item);
                      }}
                    />
                  </p>
                ));
              }
              // Handle string values if needed (like 'sortBy' or 'name')
              if (typeof value === "string" && value) {
                return (
                  <p className="searches" key={key}>
                    <span>{value}</span>
                    <FontAwesomeIcon
                      icon={faXmark}
                      onClick={() => {
                        onFilterChange(key, null);
                      }}
                    />
                  </p>
                );
              }
              return null;
            })}
            {/* <p className="searches">
              <span>Sunglasses</span>
              <FontAwesomeIcon icon={faXmark} />
            </p>
            <p className="searches">
              <span>Sunglasses</span>
              <FontAwesomeIcon icon={faXmark} />
            </p>
            <p className="searches">
              <span>Sunglasses</span>
              <FontAwesomeIcon icon={faXmark} />
            </p> */}
          </div>

        
        </div>
</div>

        

        <div className="searchdiv">
          <Form.Control
            type="search"
            placeholder="Search Eyewear, Lenses"
            {...register("name", {
              required: "Name is required",
            })}
          />
          <button className="searchbtn">
            <img
              className="searchicn"
              src={process.env.PUBLIC_URL + "/assets/images/icons/search.png"}
              onClick={handleClick}
            />
          </button>
        </div>
      </section>
    </>
  );
};

export default Search_products;
